// src/data/servicesData.js (create this file)

// Placeholder images - REPLACE these with your actual high-quality images
const placeholderImages = {
    marketing: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    digital: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1115&q=80',
    pr: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    web: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    production: 'https://images.unsplash.com/photo-1587440871875-191322ee64b0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1171&q=80',
    photo: 'https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747478902/Digisavvy/Other%20Brands%20LOGOS/neutijmkwqpyi3x8spvg.png',
  };
  
  export const services = [
    {
      id: '01',
      title: 'Marketing Services',
      image: placeholderImages.marketing,
      description: 'Cutting-edge communication solutions across Print, TV, Digital, Events & Outdoor. We craft messages, partner with your brand, and prioritize revenue generation to reach your target customer effectively.',
      readMoreLink: '/services/marketing', // Example link
    },
    {
      id: '02',
      title: 'Digital Marketing',
      image: placeholderImages.digital,
      description: 'Mastering the digital landscape with personalized, innovative SEO, SMO, SEM & PPC solutions. We tailor strategies to your specific business needs for more leads and more business.',
      readMoreLink: '/services/digital-marketing',
    },
    {
      id: '03',
      title: 'PR & Influencer Marketing',
      image: placeholderImages.pr,
      description: 'Reliable PR services (Newspaper, TV, Radio) and powerful influencer collaborations to build brand awareness, reach wider audiences, and create industry hype for qualified conversions.',
      readMoreLink: '/services/pr-influencer',
    },
    {
      id: '04',
      title: 'Website & App Design',
      image: placeholderImages.web,
      description: 'Building the backbone of your online presence. Custom websites, microsites, landing pages, and native iOS/Android apps with seamless user experiences and expert project management.',
      readMoreLink: '/services/web-app-design',
    },
    {
      id: '05',
      title: 'Production',
      image: placeholderImages.production,
      description: 'Creating compelling brand collaterals and managing marketing materials. From unique product packaging to company brochures, our design team sets your brand apart in the target market.',
      readMoreLink: '/services/production',
    },
    {
      id: '06',
      title: 'Photography/Videography',
      image: placeholderImages.photo,
      description: 'Enhancing brand perception with stunning visuals. Professional Food, Product, Portrait, and Real Estate photography/videography to build trust and drive conversions.',
      readMoreLink: '/services/photo-video',
    }
  ];